import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-10 d-flex" }

import { ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { formatNumber, formatRate } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/mte_report/mte_report': fetchList,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)
fetchData({
  reportTime: {}
})

const reportTimeRange = ref<string[]>([])
const reportTimeChange = (val: string[]) => {
  if(val) {
    reportTimeRange.value[0] = dayjs(val[0]).startOf('year').format('YYYY-MM-DD')
    reportTimeRange.value[1] = dayjs(val[1]).endOf('year').format('YYYY-MM-DD')
  } else {
    reportTimeRange.value = []
  }
  fetchData({
    reportTime: {
      from: reportTimeRange.value[0],
      to: reportTimeRange.value[1]
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_date_picker, {
        modelValue: reportTimeRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reportTimeRange).value = $event)),
        type: "daterange",
        disabled: _unref(MI_identify),
        style: {"flex-grow":"0"},
        onChange: reportTimeChange,
        "value-format": "YYYY-MM-DD",
        "start-placeholder": "报表开始日期",
        "range-separator": "至",
        "end-placeholder": "报表结束日期"
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      class: "mt-10",
      "max-height": _unref(MI_height)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "Subsidiary",
          prop: "orgName",
          "show-overflow-tooltip": "",
          width: "130",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "销售目标",
          prop: "salesTarget",
          formatter: _unref(formatNumber),
          align: "right"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "销售额",
          prop: "salesRevenue",
          formatter: _unref(formatNumber),
          "show-overflow-tooltip": "",
          align: "right"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "完成率",
          prop: "salesCompletionRate",
          formatter: _unref(formatRate)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "毛利目标",
          prop: "grossProfitTarget",
          formatter: _unref(formatNumber),
          "show-overflow-tooltip": "",
          align: "right"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "毛利",
          prop: "grossProfit",
          formatter: _unref(formatNumber),
          width: "140",
          align: "right"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "毛利率",
          prop: "grossProfitMargin",
          formatter: _unref(formatRate)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "毛利完成率",
          prop: "grossProfitCompletionRate",
          formatter: _unref(formatRate)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "成本率目标",
          prop: "costRateTarget",
          formatter: _unref(formatRate)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "净利率目标",
          prop: "netProfitMarginTarget",
          formatter: _unref(formatRate)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "净利目标",
          prop: "netProfitTarget",
          formatter: _unref(formatNumber),
          "show-overflow-tooltip": "",
          align: "right"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "净利目标(RMB)",
          prop: "netProfitTargetRmb",
          formatter: _unref(formatNumber),
          "show-overflow-tooltip": "",
          align: "right"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "净利",
          prop: "netProfit",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "净利率",
          prop: "netProfitMargin",
          formatter: _unref(formatRate)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "净利完成率",
          prop: "netProfitCompletionRate",
          formatter: _unref(formatRate)
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ])
  ]))
}
}

})